export default __webpack_public_path__ + "static/media/png.41c34cba.svg";